import { render } from "./LesTextesDetailsPage.vue?vue&type=template&id=c91cb000"
import script from "./LesTextesDetailsPage.vue?vue&type=script&lang=js"
export * from "./LesTextesDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__